import { useEffect } from 'react';
import { LoginForm } from '../../containers/authentication/loginForm/index';
import { DEFAULT_LOGIN_TYPE } from '../../containers/authentication/defaultLoginLink';
import { getAppConfig } from '../../hooks/useAppConfig';
import { goToRoute } from '@arivaa-react/react-router5';
import { hyphenToCamelCase } from '../../helpers/caseConverters';

/**
 * @description Login
 * @type Page
 * @author
 */
const Login = ({ match }) => {
  useEffect(() => {
    if (!getAppConfig('dbConfigured')) {
      goToRoute('create-db');
    }
  }, []);
  const type = hyphenToCamelCase(match.params.type || DEFAULT_LOGIN_TYPE);
  return <LoginForm type={type} />;
};

Login.displayName = 'Login';
Login.routeProps = {
  header: true,
  public: true,
  guestOnly: true,
};
Login.url = 'login/:type?';
export default Login;
